export default __webpack_public_path__ + "static/media/postpone.c83229e2.svg";